import { Subject, CustodyChain } from '.';

export interface Source {
  sourceId: string;
  sourceType: string;
  sourceTenantId: string;
  sourceTitleId: string;
}

export class Opinion {
  sentiment: string;
  comment: string;
  opinionCategoryLabels: OpinionCategoryLabels;

  constructor(traits?: OpinionCategoryLabels, comment?: string) {
    this.sentiment = 'accurate';
    this.opinionCategoryLabels = traits || {};
    this.comment = comment || '';
  }

  public getTraitCount(): number {
    return Object.keys(this.opinionCategoryLabels)
      .map<number>((key: string) => this.opinionCategoryLabels[key].length)
      .reduce((prev, cur) => prev + cur, 0);
  }
}

export type OpinionCategoryLabels = { [id: string]: string[] };

export function hasLabel(opinion: Opinion, label: string): boolean {
  return Object.keys(opinion.opinionCategoryLabels).some((key: string) => {
    return opinion.opinionCategoryLabels[key].includes(label);
  });
}

export interface Feedback {
  id?: string;
  caseDocId: string;
  sourceWeight?: number;
  groundTruth?: boolean;
  source: Source;
  subject: Subject;
  opinion: Opinion;
  feedbackDateTime: Date;
  evidence?: {
    [id: string]: string;
  };
  custodyChain?: CustodyChain[];
}
